import { EN } from "../ui/constants";

export const jsonRequest = (
  path,
  method = "GET",
  body = null,
  options = { headers: {} }
) => {
  options.headers = {
    ...options.headers,
    "Content-Type": "application/json",
  };
  return fetch(`${EN.BASE_URL}/${path}`, {
    method,
    body: !!body ? JSON.stringify(body) : undefined,
    ...options,
  }).then((res) => {
    return res.json().then((json) => {
      if (!res.ok && json.message) {
        throw new Error(json.message);
      } else if (!res.ok) {
        throw new Error("Server error: " + res.status);
      } else return json;
    });
  });
};

export const register = (
  email,
  password,
  source,
  receive_newsletter,
  receive_updates
) => {
  return jsonRequest(`register_user`, "POST", {
    email,
    password,
    source,
    receive_newsletter,
    receive_updates,
  });
};

export const login = (email, password) => {
  return jsonRequest(`login`, "POST", { email, password });
};

export const getSource = () => {
  return jsonRequest(`registration_source`);
};
export const forgotPassword = (email) => {
  return jsonRequest(`sent_forgot_email`, "POST", {
    email,
  });
};

export const setNewPassword = (token, password) => {
  return jsonRequest(`set_new_password`, "POST", { token, password });
};
